import { Ref, ref } from "vue";
import { SyainService } from "@/service/SyainService";
import { DetailData, DetailInputData } from "@/types/Syain";
import { FormUtil } from "@/utils/FormUtil";
import { AxiosError } from "axios";
import { DialogService } from "@/service/DialogService";
import { useForm } from '@/composable/form/form';

/*
 * 更新処理
 */
export function useUpdate() {
  const isUpdateing = ref(false)
  const { removeAllError } = useForm()

  // 入力内容を更新する
  const update = async (form: Ref<DetailInputData>): Promise<number | null> => {
    isUpdateing.value = true
    // エラーなしの場合
    let returnVal: number | null
    // 更新処理
    const srv = new SyainService();

    return srv.update(form.value).then(res => {
      DialogService.success({
        text: '保存しました！'
      })
      returnVal = res
    }).catch(e => {
      if (e.response.status == 413) {
        DialogService.error({
          text: '新規登録するファイルサイズが大きすぎ、登録できませんでした。'
        }, true)
      }

      // Formの入力エラーをリセット
      removeAllError(form.value)

      const err = e as AxiosError<any>
      FormUtil.setLaravelError(form.value, err)
      returnVal = null
    }).then(() => {
      /* --- finaly処理 --- */
      // 更新中フラグを解除
      isUpdateing.value = false
      return returnVal
    })
  }

  return {
    isUpdateing,
    update,
  }
}
